"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClaimTypeCodeFrenchCustomSort = exports.ClaimTypeCodeEnglishCustomSort = exports.ClaimColumnName = void 0;
/* eslint no-shadow: 0 */
var claim_type_code_1 = require("../constants/claim-type-code");
var ClaimColumnName;
(function (ClaimColumnName) {
    ClaimColumnName["AdjudicatorUserID"] = "AdjudicatorUserID";
    ClaimColumnName["ApprovedLenderEnglishName"] = "ApprovedLenderEnglishName";
    ClaimColumnName["ApprovedLenderFrenchName"] = "ApprovedLenderFrenchName";
    ClaimColumnName["ApprovedLenderReferenceNumber"] = "ApprovedLenderReferenceNumber";
    ClaimColumnName["ClaimReceivedDate"] = "ClaimReceivedDate";
    ClaimColumnName["ClaimStatusCode"] = "ClaimStatusCode";
    ClaimColumnName["ClaimTypeCode"] = "ClaimTypeCode";
    ClaimColumnName["ClaimTypeCodeEnglish"] = "ClaimTypeCodeEnglish";
    ClaimColumnName["ClaimTypeCodeFrench"] = "ClaimTypeCodeFrench";
    ClaimColumnName["ClaimTypeIndicator"] = "ClaimTypeIndicator";
    ClaimColumnName["CmhcLoanAccountNumber"] = "CmhcLoanAccountNumber";
    ClaimColumnName["MinimumApprovalRoleTypeCode"] = "MinimumApprovalRoleTypeCode";
    ClaimColumnName["ProcessClaimInMICSResultFlag"] = "ProcessClaimInMICSResultFlag";
    ClaimColumnName["RecordCreatedTimestamp"] = "RecordCreatedTimestamp";
    ClaimColumnName["RecordUpdatedTimestamp"] = "RecordUpdatedTimestamp";
    ClaimColumnName["UserID"] = "UserID";
})(ClaimColumnName = exports.ClaimColumnName || (exports.ClaimColumnName = {}));
exports.ClaimTypeCodeEnglishCustomSort = "CASE \n  " + Object.values(claim_type_code_1.ClaimTypeCodeEnglish)
    .map(function (claimTypeCode, index) {
    return "WHEN " + ClaimColumnName.ClaimTypeCode + " = '" + claimTypeCode + "' THEN " + (index + 1);
})
    .join(' ') + "\n  ELSE 6 \n  END";
exports.ClaimTypeCodeFrenchCustomSort = "CASE \n  " + Object.values(claim_type_code_1.ClaimTypeCodeFrench)
    .map(function (claimTypeCode, index) {
    return "WHEN " + ClaimColumnName.ClaimTypeCode + " = '" + claimTypeCode + "' THEN " + (index + 1);
})
    .join(' ') + "\n  ELSE 6 \n  END";
